module.exports = "<app-header></app-header>\n<app-ai></app-ai>\n<div (click)=\"toggle()\">\n    <router-outlet></router-outlet>\n</div>"